import { Route } from '@angular/router';
import { EventSelectionComponent } from './event-selection/event-selection.component';
import { BookingFormComponent } from './booking-form/booking-form.component';
import { BookingFormByLocationComponent } from './booking-form-by-location/booking-form-by-location.component';
import { eventSlugExistsGuard } from './event-slug-exists.guard';
import { BookingFormByDateComponent } from './booking-form-by-date/booking-form-by-date.component';
import { bookingBasicsGuard } from './booking-basics.guard';
import { BookingPersonsComponent } from './booking-persons/booking-persons.component';
import { BookingSummaryComponent } from './booking-summary/booking-summary.component';
import { BookingShippingComponent } from './booking-shipping/booking-shipping.component';
import { BookingTokensComponent } from './booking-tokens/booking-tokens.component';
import { SuccessComponent } from './success/success.component';

export const appRoutes: Route[] = [
  {
    path: '',
    component: EventSelectionComponent
  },
  {
    path: 'booking/persons',
    component: BookingPersonsComponent,
    canActivate: [bookingBasicsGuard]
  },
  {
    path: 'booking/tokens',
    component: BookingTokensComponent,
    canActivate: [bookingBasicsGuard]
  },
  {
    path: 'success',
    component: SuccessComponent
  },
  {
    path: 'booking/shipping',
    component: BookingShippingComponent,
    canActivate: [bookingBasicsGuard]
  },
  {
    path: 'booking/summary',
    component: BookingSummaryComponent,
    canActivate: [bookingBasicsGuard]
  },
  {
    path: 'booking/:eventSlug',
    component: BookingFormComponent,
    canActivate: [eventSlugExistsGuard]
  },
  {
    path: 'booking/:eventSlug/date',
    component: BookingFormByDateComponent,
    canActivate: [eventSlugExistsGuard]
  },
  {
    path: 'booking/:eventSlug/location',
    component: BookingFormByLocationComponent,
    canActivate: [eventSlugExistsGuard]
  },
];

